export default __webpack_public_path__ + "static/media/RadicalRocks_03.85f05159.png";